import React, { Suspense, useRef } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, FormGroup, Form, Row, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import axios from "../config/axios";
import { handleAxiosResponseError } from "../utils/handleResponseError";
import Compressor from "compressorjs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./user.module.css";
import useUserStore from "store/user";
import Spinner from "components/Spinner";

function User() {
  const { register, handleSubmit } = useForm();

  const { user, setUser } = useUserStore();
  const imageRef = useRef();

  const onSubmit = (data) => {
    const { password, confirmPassword } = data;

    if (password && password.length < 8) {
      toast.warning("Passwords must contain at-least 8 characters");
      return;
    }

    if (password && confirmPassword && password !== confirmPassword) {
      toast.warning("Passwords does not match! Please try to re-enter");
      return;
    }

    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/auth/admin/current/update`, data)
      .then(({ data }) => {
        toast.success("Your Profile Has Been Updated");
        setUser({ ...user, ...data.admin });
      })
      .catch((err) => {
        toast.error(handleAxiosResponseError(err));
      });
  };

  const handleClick = () => {
    imageRef.current.click();
  };

  const handleChange = (e) => {
    const file = e.target.files[0];

    new Compressor(file, {
      quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
      success: (compressedResult) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedResult);
        reader.onloadend = () => {
          axios
            .put(`${process.env.REACT_APP_SERVER_URL}/api/auth/admin/current/profile`, { image: reader.result })
            .then(() => {
              // setImage(reader.result);
              console.log("Your Profile Has Been Updated");
              setUser({ ...user, image: reader.result });
            })
            .catch((err) => {
              console.log(handleAxiosResponseError(err));
            });
        };
      },
    });

    e.target.value = null;
  };

  return (
    <Suspense fallback={<Spinner />}>
      <Row>
        <Col md="4">
          <Card className="card-user">
            <div className="image">
              <img alt="..." src={require("assets/img/account-background.jpg").default} />
            </div>
            <CardBody>
              <div className="author">
                <div className={styles.container}>
                  <img
                    alt="..."
                    className={`avatar border-gray mx-auto ${styles.image}`}
                    // src={require('assets/img/default-avatar.png').default}
                    src={user?.image ? user.image : require("assets/img/default-avatar.png").default}
                  />
                  <div className={styles.middle}>
                    <button size="sm" className="btn-rounded account_btn" style={{ backgrounColor: "#97c3e6" }} onClick={handleClick}>
                      Upload Image
                    </button>
                    <input type={"file"} ref={imageRef} onChange={handleChange} style={{ display: "none" }} />
                  </div>
                </div>
                <h5 className="title" style={{ color: "#97c3e6" }}>
                  {user?.firstName} {user?.lastName}
                </h5>
              </div>
              <p className="description text-center">{user?.aboutME}</p>
            </CardBody>
          </Card>
        </Col>
        <Col md="8">
          <Card className="card-user">
            <CardHeader>
              <CardTitle className="text-secondary" tag="h5">
                Edit Profile
              </CardTitle>
            </CardHeader>
            <CardBody>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col className="" md="12">
                    <FormGroup className="d-block">
                      <label htmlFor="exampleInputEmail1">Email address</label>
                      <input
                        defaultValue={user ? user.email : ""}
                        placeholder="Email"
                        type="email"
                        name="email"
                        className="form-control"
                        disabled
                        // {...register('email')}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <FormGroup className="d-block">
                      <label>First Name</label>
                      <input
                        defaultValue={user ? user.firstName : ""}
                        placeholder="First Name"
                        className="form-control"
                        type="text"
                        {...register("firstName")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="d-block">
                      <label>Last Name</label>
                      <input
                        defaultValue={user ? user.lastName : ""}
                        placeholder="Last Name"
                        className="form-control"
                        type="text"
                        {...register("lastName")}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {/* <Row>
                    <Col className="pr-1" md="4">
                      <FormGroup className="d-block">
                        <label>City</label>
                        <input
                          defaultValue={user ? user.city : ""}
                          placeholder="City"
                          type="text"
                          className="form-control"
                          {...register("city")}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="px-1" md="4">
                      <FormGroup className="d-block">
                        <label>Country</label>
                        <input
                          defaultValue={user ? user.country : ""}
                          placeholder="Country"
                          type="text"
                          className="form-control"
                          {...register("country")}
                        />
                      </FormGroup>
                    </Col>
                    <Col className="pl-1" md="4">
                      <FormGroup className="d-block">
                        <label>Postal Code</label>
                        <input
                          defaultValue={user ? user.zipcode : ""}
                          placeholder="ZIP Code"
                          type="number"
                          className="form-control"
                          {...register("zipcode")}
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}
                <Row>
                  <Col md="12">
                    <FormGroup className="d-block">
                      <label>About Me</label>
                      <textarea
                        type="textarea"
                        defaultValue={user ? user.aboutME : ""}
                        className="form-control"
                        {...register("aboutME")}
                      ></textarea>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm="12">
                    <CardTitle className="text-secondary" tag="h5">
                      Set New Password
                    </CardTitle>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <FormGroup className="d-block">
                      <input placeholder="Password" className="form-control" type="text" {...register("password")} />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup className="d-block">
                      <input placeholder="Confirm Password" className="form-control" type="text" {...register("confirmPassword")} />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col sm="12">
                    <CardTitle className="text-secondary" tag="h5">
                      Social
                    </CardTitle>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Calendar</label>
                      <input
                        defaultValue={user ? user.calender : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("calender")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Drive</label>
                      <input
                        defaultValue={user ? user.drive : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("drive")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Facebook</label>
                      <input
                        defaultValue={user ? user.facebook : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("facebook")}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Google Classroom</label>
                      <input
                        defaultValue={user ? user.classroom : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("classroom")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Gmail</label>
                      <input
                        defaultValue={user ? user.gmail : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("gmail")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Instagram</label>
                      <input
                        defaultValue={user ? user.instagram : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("instagram")}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>LMS</label>
                      <input
                        defaultValue={user ? user.blackboard : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("blackboard")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>School</label>
                      <input
                        defaultValue={user ? user.institute : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("institute")}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Twitter</label>
                      <input
                        defaultValue={user ? user.twitter : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("twitter")}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup className="d-block">
                      <label>Student Information System</label>
                      <input
                        defaultValue={user ? user?.student : ""}
                        placeholder="Add link"
                        type="url"
                        className="form-control"
                        {...register("student")}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <div className="update ml-auto mr-auto">
                    <button className="btn-round account_btn" type="submit">
                      Update Profile
                    </button>
                  </div>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Suspense>
  );
}

export default User;
